import {connect} from '@modifi/redux'

import HeaderNavigation, {HeaderNavigationProps} from './HeaderNavigation'
import {selectTopNavigation, selectExtraLinks} from '../../../data/navigation'
import {LoginButtonProps} from './components/login-button/LoginButton'

const mapStateToProps = (
  state: Record<string, any>
): Pick<HeaderNavigationProps, 'headerRoutes'> & Pick<LoginButtonProps, 'loginUrl'> => ({
  headerRoutes: selectTopNavigation(state),
  loginUrl: selectExtraLinks(state)?.login,
})

const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(HeaderNavigation)
